/*
 THIS HAS A SANDBOX OF ALL UI/FORM ELEMENTS
 */

import { Component, OnInit } from '@angular/core';
import { en_US, NzI18nService } from 'ng-zorro-antd/i18n';

/* Tree */
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';
import { AppMetadataHandler } from 'app'



@Component({
    selector: 'app-demo-sandbox',
    templateUrl: './demo-sandbox.component.html',
    styleUrls: ['./demo-sandbox.component.scss']
})

export class DemoSandboxComponent implements OnInit {

    constructor(
        private i18n: NzI18nService,
        public appMetadataHandler: AppMetadataHandler
    ) {
    }

    date = null; // new Date();
    dateRange = []; // [ new Date(), addDays(new Date(), 3) ];
    isEnglish = false;
    optionTEMP
    value
    cardCollapsed
    savedAdd

    onChange(result: Date): void {
        console.log('onChange: ', result);
    }

    selectedValue:any;
    loadFaker() {};


    list = [
        1,2,3
    ]


    changeLanguage(): void {
        this.i18n.setLocale(en_US);
        this.isEnglish = !this.isEnglish;
    }

    options = [
        {
            label: 'Audi',
            value: 'audi',
            children: [{
                label: 'A3',
                value: 'a3',
                children: [
                    {label: 'Luxury i8',value: 'i8',isLeaf: true},
                    {label: 'Sedan i50',value: 'u',isLeaf: true},
                    {label: 'Convertible i5',value: 'hu',isLeaf: true},
                ]
            },
                {label: 'C5',value: 'C5',isLeaf: true},
                {label: 'D4',value: 'C5',isLeaf: true},
                {label: 'X6',value: 'C5',isLeaf: true},
                {label: 'X9',value: 'C5',isLeaf: true},
                {label: 'C1',value: 'C5',isLeaf: true},
                {label: 'X5',value: 'C5',isLeaf: true},
                {label: 'Z5',value: 'C5',isLeaf: true},
            ]
        },
        {
            value: 'BMW',
            label: 'BMW',
            children: [{
                value: 'roadster',
                label: 'Roadster',
                children: [{
                    value: 'i8',
                    label: 'i8',
                    isLeaf: true
                }]
            }]
        }];


    ngOnInit(): void {
        this.transferListGen(); /* Generate Transfer List's random data dynamically */
    }

    /* Slider */
    slider_value = 16;
    radioValue = "B";

    public nzOptions = this.options;

    /** ngModel value */
    public values: any[] = [{
        value: 'audi',
        label: 'Audi'
    }, {
        value: 'a3',
        label: 'A3'
    }, {
        value: 'i8',
        label: 'Luxury i8'
    }];

    public onChanges(values: any): void {
        console.log(values, this.values);
    }

    /* Inputs */
    username: string = "@thinkdj";

    /* Checkbox */
    allChecked = false;
    indeterminate = true;
    isTrue = true;
    checkOptionsOne = [
        { label: 'Freebies', value: 'a', checked: true },
        { label: 'Addons', value: 'b', checked: false },
        { label: 'Riders', value: 'c444', checked: false }
    ];
    updateAllChecked(): void {
        this.indeterminate = false;
        if (this.allChecked) {
            this.checkOptionsOne.forEach(item => item.checked = true);
        } else {
            this.checkOptionsOne.forEach(item => item.checked = false);
        }
    }
    updateSingleChecked(): void {
        if (this.checkOptionsOne.every(item => item.checked === false)) {
            this.allChecked = false;
            this.indeterminate = false;
        } else if (this.checkOptionsOne.every(item => item.checked === true)) {
            this.allChecked = true;
            this.indeterminate = false;
        } else {
            this.indeterminate = true;
        }
    }


    /* Sample Menu */
    isCollapsed = true;

    toggleCollapsed(): void {
        this.isCollapsed = !this.isCollapsed;
    }

    /* Star Rating */
    ratingValue = 3.5;
    
    
    /* Carousel */
    carouselArray = [1,2,3,4,5];
    

    /* TREE
    -- requires NzFormatEmitEvent, NzTreeNode imports
    */

    defaultCheckedKeys = [ '0-0-0' ];
    defaultSelectedKeys = [];
    defaultExpandedKeys = [ '0-0', '0-0-0', '0-0-1' ];

    nodes = [ {
        title   : 'Autofirst',
        key     : '0-0',
        expanded: true,
        children: [ {
            title   : 'My Package',
            key     : '0-0-0',
            children: [
                { title: 'Rider A', key: '0-0-0-0', isLeaf: true },
                { title: 'Rider X', key: '0-0-0-1', isLeaf: true },
                { title: 'Freebie 2X', key: '0-0-0-2', isLeaf: true }
            ]
        }, {
            title   : 'My Package PRO',
            key     : '0-0-1',
            children: [
                { title: 'Addon A', key: '0-0-1-0', isLeaf: true },
                { title: 'Addon C', key: '0-0-1-1', isLeaf: true },
                { title: 'Addon CF', key: '0-0-1-2', isLeaf: true }
            ]
        }, {
            title : 'Gold',
            key   : '0-0-2',
            isLeaf: true
        } ]
    }, {
        title   : 'TravelAssure',
        key     : '0-1',
        children: [
            { title: 'TravelShort', key: '0-1-0-0', isLeaf: true },
            { title: 'Travellong', key: '0-1-0-1', isLeaf: true },
            { title: 'Travel Plus+', key: '0-1-0-2', isLeaf: true }
        ]
    }
    ];

    nzEvent(event: NzFormatEmitEvent): void {
        console.log(event);
    }


    /* Switch */
    switchValue = false;
    loading = false;

    clickSwitch(): void {
        if (!this.loading) {
            this.loading = true;
            setTimeout(() => {
                this.switchValue = !this.switchValue;
                this.loading = false;
            }, 3000);
        } /* endif */
    } /* end fn */




    /* Transfer */
    list_transfer: any[] = [];
    disabledTransfer = false;

    transferListGen(): void {
        for (let i = 0; i < 20; i++) {
            this.list_transfer.push({
                key     : i.toString(),
                title   : `Addon ${i + 1}`,
                disabled: i % 3 < 1,
            });
        }
        [ 2, 3 ].forEach(idx => this.list_transfer[ idx ].direction = 'right');
    };

    selectTransferList(ret: {}): void {
        console.log('nzSelectChange', ret);
    }
    changeTransferList(ret: {}): void {
        console.log('nzChange', ret);
    }
    
    /* Modal */
    isVisibleMiddle :boolean = false;
    showModalMiddle(): void {
        this.isVisibleMiddle = true;
    }
    handleOkMiddle(): void {
        console.log('Modal: click ok');
        this.isVisibleMiddle = false;
    }
    handleCancelMiddle(): void {
        this.isVisibleMiddle = false;
    }
    
    
    /* Table */
    displayData = [];
    dataTable = [
        {
            name    : 'John Brown',
            age     : 32,
            address : 'New York No. 1 Lake Park',
            checked : false,
            disabled: false
        },
        {
            name    : 'Jim Green',
            age     : 42,
            address : 'London No. 1 Lake Park',
            checked : false,
            disabled: false
        },
        {
            name    : 'Joe Black',
            age     : 32,
            address : 'Sidney No. 1 Lake Park',
            checked : false,
            disabled: false
        },
        {
            name    : 'Disabled User',
            age     : 32,
            address : 'Sidney No. 1 Lake Park',
            checked : false,
            disabled: true
        }
    ];

    currentPageDataChange($event: Array<{ name: string; age: number; address: string; checked: boolean; disabled: boolean; }>): void {
        this.displayData = $event;
        this.refreshStatus();
    }

    refreshStatus(): void {
        const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
        const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
        this.allChecked = allChecked;
        this.indeterminate = (!allChecked) && (!allUnChecked);
    }

    checkAll(value: boolean): void {
        this.displayData.forEach(data => {
            if (!data.disabled) {
                data.checked = value;
            }
        });
        this.refreshStatus();
    }
    
    
    
    
    /* Drawers */
    visibleDrawer1 = false;
    openDrawer1(): void { this.visibleDrawer1 = true; }
    closeDrawer1(): void { this.visibleDrawer1 = false; }

    visibleDrawer2 = false;
    openDrawer2(): void { this.visibleDrawer2 = true; }
    closeDrawer2(): void { this.visibleDrawer2 = false; }

}
